export default () => ({
    currentTab: 1,

    setActiveTab(activeTab) { 
        this.currentTab = activeTab 
    },

    isActiveTab(activeTab) {
        return this.currentTab === activeTab
    }
    
})